<template>
  <el-select v-model="selected" filterable clearable style="width: 100%">
    <el-option
      v-for="(item, index) in data"
      :key="index"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    current: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      curr: null,
    };
  },
  computed: {
    selected: {
      get() {
        const current = this.data.find(
          (item) => item.id === (this.curr || this.current)
        );
        return current ? current.name : "";
      },
      set(val) {
        this.curr = val;
        this.$emit("selected", val);
      },
    },
  },
};
</script>
